import React from 'react';
import {
  BooleanField,
  Datagrid,
  DateField,
  SelectField,
  TextField
} from 'react-admin';

import List from '../List';
import { TemplateTypes } from './constants';

const TemplateList = props => (
  <List {...props} sort={{ field: 'updated_at', order: 'DESC' }}>
    <Datagrid rowClick="show" bulkActionButtons={false} sx={{
      '& .RaDatagrid-headerCell': { fontWeight: 600, textTransform: 'uppercase', fontSize: 12, color: 'text.secondary' },
      '& .RaDatagrid-row:hover': { backgroundColor: 'action.hover' }
    }}>
      <TextField source="name" />
      <TextField source="version" />
      <SelectField source="type" choices={TemplateTypes} />
      <BooleanField source="hasHotspots" />
      <TextField source="templateFile.name" label="Prod File" sortable={false} />
      <TextField source="betaTemplateFile.name" label="Beta File" sortable={false} />
      <DateField source="updated_at" showTime />
      <BooleanField source="betaEnabled" label="Beta" />
      <BooleanField source="disabled" />
    </Datagrid>
  </List>
);

export default TemplateList;
